import { render, staticRenderFns } from "./TheEmpty.vue?vue&type=template&id=198133dd&scoped=true&"
import script from "./TheEmpty.vue?vue&type=script&lang=js&"
export * from "./TheEmpty.vue?vue&type=script&lang=js&"
import style0 from "./TheEmpty.vue?vue&type=style&index=0&id=198133dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198133dd",
  null
  
)

export default component.exports